var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-redirect"},[(!!_vm.status)?_c('QueryInfo',{attrs:{"mode":_vm.status}}):_c('InQuery')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }